import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faSun, 
  faMoon, 
  faListCheck, 
  faChartBar, 
  faTrash, 
  faClock, 
  faHourglass,
  faCircle,
  faCircleExclamation,
  faCircleCheck,
  faPlus,
  faChevronUp,
  faChevronDown,
  faChartLine,
  faTachometerAlt
} from '@fortawesome/free-solid-svg-icons';
import { faGithub, faInstagram } from '@fortawesome/free-brands-svg-icons';

library.add(
  faSun, 
  faMoon, 
  faListCheck, 
  faChartBar, 
  faTrash, 
  faClock, 
  faHourglass,
  faCircle,
  faCircleExclamation,
  faCircleCheck,
  faPlus,
  faChevronUp,
  faChevronDown,
  faChartLine,
  faTachometerAlt,
  faGithub,
  faInstagram
);